<template>

  <!-- TOP BAR TITLE -->
  <transition name="fade" v-if="showCreateScenarioModal" style="z-index: 3000">
    <Modal :big="false">
      <template v-slot:header>
        <div class="d-flex justify-content-between align-items-center w-100" style="min-width: 40vw">
          <div></div>
          <h3 class="fs-3 fw-bold">Create Scenario </h3>
          <button class="btn btn-primary btn-xl" @click="showCreateScenarioModal = false">
            <i class="fa fa-close"></i>
          </button>
        </div>
      </template>

      <!-- + CREATE SCENARIO MODAL-->
      <template v-slot:body>
        <div class="d-flex flex-column align-items-center col-12">

          <div class="d-flex col-12 flex-column mb-5 p-0">
            <p class="fs-5 text-center">This tool allows you to clone and label this case as a scenario. <br>
              You can then modify the new scenario while keeping the original scenario intact.</p>
            <div class="d-flex justify-content-center">
              <div class="" style="max-width: 200px">
                <label for="scenarioName" class="fs-5 fw-bold ml-2">Scenario Name</label>
                <input type="text" class="form-control-lg fs-5  mb-5 w-100" placeholder="Best Case" v-model="scenarioName" />
              </div>
            </div>

          </div>
          <div><button class="btn btn-primary btn-xl" @click="createScenario">Create</button></div>
        </div>
      </template>
    </Modal>
  </transition>

  <!-- Manage Scenarios Modal in Case Details -->
  <div class="d-flex col-12 p-1 m-1">
    <div class="col-12 p-0 mx-2 d-flex flex-row">
      <div class="col-12 fs-5 p-0 m-0 d-flex flex-column">
        <div class="d-flex w-100 flex-column">
          <!-- {{ selectedCase?.Id }} -->
          <p class="text-center">
            These are the scenarios you've created for this case.
          </p>
          <p class="text-center"> You can edit their names, delete scenarios, or add new ones while
            keeping the original scenario intact.</p>
          <div class="d-flex justify-content-center card-body">
            <table v-if="caseStore.selectedCaseScenarios?.length > 0" class="table table-bordered fs-5 w-75">
              <thead>
                <tr>
                  <th class="text-start">Scenario Name</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <!-- {{ caseStore.selectedCaseScenarios }} -->
                <!-- {{ this.$route.params?.caseId }} -->
                <!-- {{ caseStore.selectedCaseScenarios.Id }} -->
                <tr v-for="scenario in caseStore.selectedCaseScenarios" :key="scenario.ParentCaseId">
                  <td class="text-start">
                    <span v-if="editScenarioId !== scenario.Id" :class="{ 'fw-bold': scenario.Id == $route.params?.caseId }">
                      {{ scenario.ScenarioName }} (ID: {{ scenario.Id }})
                    </span>

                    <span v-else>
                      <input type="text" v-model="editedScenarioName" class="form-control form-control-lg" style="width: 200px" />
                    </span>

                    <div class="d-flex align-items-center"></div>
                  </td>

                  <td class="text-center">
                    <div v-if="editScenarioId === scenario.Id">
                      <button class="btn btn-primary btn-xl ms-2" @click="saveScenarioName(scenario, editedScenarioName)">
                        Save Name
                      </button>
                      <button class="btn btn-primary btn-xl ms-2" @click="cancelEdit">
                        Back
                      </button>
                    </div>

                    <div v-else>
                      <router-link v-if="scenario.Id != this.$route.params?.caseId" :to="`/Cases/${scenario.Id}`">
                        <button v-if="scenario.Id !== $route.params?.caseId" class="btn btn-primary btn-xl fs-5" @click="switchToCase(scenario.Id)">
                          View
                        </button>


                      </router-link>
                      <span v-else class="fs-5 pr-5 fw-bold"> Active </span>


                      <button class="btn btn-primary btn-xl me-3" @click="startEditScenario(scenario)">
                        Edit Name
                      </button>
                      <button class="btn btn-outline btn-xl" @click="deleteCase(scenario.Id)">
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="card-body" v-else>
              <p class="text-center">
                You haven't created any scenarios for this case yet.
              </p>
            </div>

          </div>

          <!-- Add New Scenario -->
          <div class="d-flex justify-content-center mt-2">
            <button class="btn btn-primary btn-xl " @click="showCreateScenarioModal = true">
              <i class="fa fa-plus mr-3"></i>
              Create Scenario
            </button>
            <!-- {{ showCreateScenarioModal }} -->
          </div>
          <!-- <div class="mt-4">
            <button class="btn btn-primary btn-xl" @click="showCreateScenarioModal = true">
                          <i class="fa fa-plus mr-3"></i>
                          Create Scenario
            </button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Modal from "../../../components/utils/Modal.vue";
import { useCaseStore } from "../../../stores/CaseStore";
export default {
  name: "Scenarios",
  components: {Modal},
  props: [ "scenarios", "selectedCase", "charges"],
  data() {
    return {
      
      editScenarioId: null, // Tracks the ID of the scenario being edited
      editedScenarioName: "", // Tracks the new scenario name
      showCreateScenarioModal: false,
      scenarioCantBeEmptyMessage: false,
      caseStore: useCaseStore(),

      copyScenarioObject: {
        charges: true,
        chargeSettings: true,
        probationLimitations: true,
        probationFactors: true,
        custodyCredits: true,
        releaseDate: true,
        currentScenarioId: null,

      },
      parentCaseChildren: null,

    };
  },
  async mounted() {
     this.currentScenarioId = this.$route.params.caseId;
    console.log('Current Scenario ID:', this.currentScenarioId);
    this.parentCaseChildren = await this.caseStore.loadCaseChildren(this.selectedCase.Id);
    console.log('Parent Case Children:', this.parentCaseChildren);
  },
  watch: {
  $route(to) {
    this.currentScenarioId = parseInt(to.params.id, 10);
    console.log("Updated Current Scenario ID:", this.currentScenarioId);
  },
},

  methods: {

    switchToCase(caseId) {
      if (caseId !== this.$route.params?.caseId) {
        this.$router.push(`/Cases/${caseId}`);
      } else {
        // Force page refresh if already on the same route
        this.$router.replace(`/Cases/${caseId}`);
      }
    },


    selectCase(r) {
      this.caseStore.selectedCaseId = r.Id
    },

    navigateToScenario(scenarioId) {
      console.log("Navigate to scenario:", scenarioId);
      if (scenarioId) {
        this.$router.push(`/Cases/${scenarioId}`);
      } else {
        console.error("Invalid scenarioId:", scenarioId);
      }
    },

    async createScenario(){
      console.log('Selected Case Copied Values: ', this.selectedCase)
      const scenarioObject = {
        CaseNumber: this.selectedCase?.CaseNumber,
        ComplaintDate: this.selectedCase?.ComplaintDate,
        DefendantBirthdate: this.selectedCase?.DefendantBirthdate,
        DefendantFirstName: this.selectedCase?.DefendantFirstName,
        DefendantLastName: this.selectedCase?.DefendantLastName,
        DefendantMiddleName: this.selectedCase?.DefendantMiddleName,
        CaseStatus: this.selectedCase?.CaseStatus,
        OwnerId: this.selectedCase?.OwnerId,
        HasSuperStrike: this.selectedCase?.HasSuperStrike,
        DefendantIs1170Ineligible: this.selectedCase?.DefendantIs1170Ineligible,
        ProbationStatus: this.selectedCase?.ProbationStatus,
        ScenarioName: this.scenarioName
      };
      if (this.selectedCase?.ParentCaseId) {
        scenarioObject.ParentCaseId = this.selectedCase?.ParentCaseId;
      } else {
        scenarioObject.ParentCaseId = this.selectedCase?.Id;
      };
      if (this.copyScenarioObject.custodyCredits) {
        scenarioObject.Attributes = this.selectedCase?.Attributes;
      }
      if (this.copyScenarioObject.releaseDate) {
        scenarioObject.SurrenderDate = this.selectedCase?.SurrenderDate;
      } 

      console.log('Scenario Object:',scenarioObject);
      const createdCase = await axios.post(process.env.VUE_APP_ENDPOINT + "/api/cases", scenarioObject, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ` + localStorage.getItem("user_token"),
        },
      }).then(res => res.data).catch(err => console.log(err));
      console.log('Created case w/o dc', createdCase);
      const duplicatedChildren = await this.caseStore.duplicateCaseChildren(this.parentCaseChildren, createdCase.Id);
      console.log('Duplicated caseCircumstances', duplicatedChildren.caseCircumstances);
      console.log('Duplicated caseProbationFactors', duplicatedChildren.caseProbationFactors);
      console.log('Duplicated caseProbationLimitations', duplicatedChildren.caseProbationLimitations);
      console.log('Duplicated charges', duplicatedChildren.charges);

      // createdCase.caseCircumstances = duplicatedChildren.caseCircumstances;
      // createdCase.caseProbationFactors = duplicatedChildren.caseProbationFactors;
      // createdCase.caseProbationLimitations = duplicatedChildren.caseProbationLimitations;
      // createdCase.charges = duplicatedChildren.charges;

      // console.log('Created Case Object w/duplicated children:', createdCase);

      const createdResponses = await this.caseStore.createAllCaseChildren(
        createdCase.Id,
        duplicatedChildren
      );

      console.log('Created Case Children Responses:', createdResponses);


    //  const patchCaseChildren = await this.caseStore.patchCaseChildren(createdCase.Id, duplicatedChildren);
    //   console.log('Patch children',patchCaseChildren);
    //   createdCase.caseCircumstances = duplicatedChildren.caseCircumstances;

      // this.selectedCase.push(createdCase);

      //Where to push the new scenario  that was created 
      // this.scenarios.push(createdCase);
      window.location.href = `/Cases/${createdCase.Id}`;
    },

    startEditScenario(scenario) {
      // Enter edit mode
      this.editScenarioId = scenario.Id;
      this.editedScenarioName = scenario.ScenarioName;
    },
    cancelEdit() {
      // Exit edit mode
      this.editScenarioId = null;
      this.editedScenarioName = "";
    },
    async saveScenarioName(scenario, editedScenarioName) {
      this.scenarioCantBeEmptyMessage = false;
      if (!editedScenarioName.trim()) {
        this.scenarioCantBeEmptyMessage = true;
        // alert("Scenario name cannot be empty");
        return;
      }

      try {
        const response = await axios.patch(
          `${process.env.VUE_APP_ENDPOINT}/api/cases/scenarioName/${scenario.Id}/${editedScenarioName}`,
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
            },
          }
        );

        if (response.data.success) {
          // Update the scenario name locally
          scenario.ScenarioName = editedScenarioName;

          // Exit edit mode
          this.cancelEdit();
        } else {
          console.error("Failed to update scenario name:", response.data.message);
        }
      } catch (error) {
        console.error("Error updating scenario name:", error);
      }
    },

    async deleteCase(caseId) {
      const token = localStorage.getItem("user_token");
      // console.log(token);
      console.log('Deleting Case ID: ', caseId);

      // console.log(result);

      // this.loadNow();
      const scenarios = this.caseStore.selectedCaseScenarios.filter(c => c.ParentCaseId == caseId)
      for (const scenario of scenarios) {
        console.log('DELETES SCENARIO', scenario.Id)
        await this.deleteCase(scenario.Id)
      }

      const victimQuery = {
        field: "*",
        table: "Victims",
        condition: `CaseId = ${caseId}`,
      };
      const victimList = await axios
        .post(process.env.VUE_APP_ENDPOINT + "/api/dbtable/fetchAll/", victimQuery, {
          headers: { Authorization: `Bearer ` + token },
        })
        .then((results) => {
          // console.log(results);
          return results.data.data;
        });
      if (victimList.length > 0) {
        victimList.forEach(async (victim) => {
          const deletedVictim = await axios
            .delete(process.env.VUE_APP_ENDPOINT + `/api/victims/${victim.Id}`, {
              headers: { Authorization: `Bearer ` + token },
            })
            .then((result) => {
              // console.log(result);
            });
        });
      }
      const chargeQuery = {
        field: "*",
        table: "Charge",
        condition: `CaseId = ${caseId}`,
      };
      const chargeList = await axios
        .post(process.env.VUE_APP_ENDPOINT + "/api/dbtable/fetchAll/", chargeQuery, {
          headers: { Authorization: `Bearer ` + token },
        })
        .then((results) => {
          // console.log(results);
          return results.data.data;
        });
      if (chargeList.length > 0) {
        chargeList.forEach(async (charge) => {
          const deletedcharge = await axios
            .delete(process.env.VUE_APP_ENDPOINT + `/api/charges/${charge.Id}`, {
              headers: { Authorization: `Bearer ` + token },
            })
            .then((result) => {
              // console.log(result);
            });
        });
      }
      const deletedCaseProbationLimitations = await axios.delete(process.env.VUE_APP_ENDPOINT + `/api/caseProbationLimitationStatus/byCase/${caseId}`, {
        headers: { Authorization: `Bearer ` + token },
      }).then(async (result) => {
        // console.log(result);
        return result;
      })
      .catch((err) => {
        console.error(err);
      });
      const deletedCaseProbationFactors = await axios.delete(process.env.VUE_APP_ENDPOINT + `/api/caseProbationFactors/byCase/${caseId}`, {
        headers: { Authorization: `Bearer ` + token },
      }).then(async (result) => {
        // console.log(result);
        return result;
      })
      .catch((err) => {
        console.error(err);
      });
      const deletedCase = await axios
        .delete(process.env.VUE_APP_ENDPOINT + `/api/cases/${caseId}`, {
          headers: { Authorization: `Bearer ` + token },
        })
        .then(async (result) => {
          // console.log(result);
          this.caseStore.removeCaseFromStore(caseId)
          return result;
        })
        .catch((err) => {
          console.error(err);
        });
      this.deleteCaseModal = false;
      this.caseStore.loadCases();
    },


    async deleteScenario(scenario) {
      console.log("Delete scenario:", scenario);
      console.log("Delete scenario ID:", scenario.Id);
    try {
      const response = await axios.delete(
        `${process.env.VUE_APP_ENDPOINT}/api/cases/scenario/${scenario.Id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        }
      );

      if (response.data.success) {
        console.log("Successfully deleted scenario:", response.data);
        this.selectedCase.scenarios = this.selectedCase.scenarios.filter((item) => item.Id !== scenario.Id);
      } else {
        console.error("Failed to delete scenario:", response.data.message);
      }
    } catch (error) {
      console.error("Error deleting scenario:", error);
    }
},

    addScenario() {
      console.log("Add new scenario");
    },
  },
};
</script>

  <style scoped>
  .table {
    margin-top: 20px;
  }
  
  .table th,
  .table td {
    padding: 10px;
    vertical-align: middle;
  }
  
  .btn-xl {
    padding: 10px 20px;
    font-size: 1rem;
  }
  
  .btn-lg {
    padding: 10px 20px;
    font-size: 1.1rem;
  }
  </style>
  